import { Injectable } from '@angular/core';

export interface LoadingMetrics {
  moduleName: string;
  loadTime: number;
  timestamp: Date;
  success: boolean;
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class PerformanceMonitorService {
  private loadingMetrics: LoadingMetrics[] = [];
  private loadingStartTimes = new Map<string, number>();

  startModuleLoading(moduleName: string): void {
    this.loadingStartTimes.set(moduleName, performance.now());
    console.log(`Started loading module: ${moduleName}`);
  }

  endModuleLoading(moduleName: string, success: boolean = true, error?: string): void {
    const startTime = this.loadingStartTimes.get(moduleName);
    if (startTime) {
      const loadTime = performance.now() - startTime;
      const metrics: LoadingMetrics = {
        moduleName,
        loadTime,
        timestamp: new Date(),
        success,
        error
      };

      this.loadingMetrics.push(metrics);
      this.loadingStartTimes.delete(moduleName);

      console.log(`Module ${moduleName} loaded in ${loadTime.toFixed(2)}ms`, success ? '✓' : '✗');

      if (!success && error) {
        console.error(`Module loading error:`, error);
      }
    }
  }

  getLoadingMetrics(): LoadingMetrics[] {
    return [...this.loadingMetrics];
  }

  getAverageLoadTime(): number {
    if (this.loadingMetrics.length === 0) return 0;

    const totalTime = this.loadingMetrics
      .filter(m => m.success)
      .reduce((sum, m) => sum + m.loadTime, 0);

    return totalTime / this.loadingMetrics.filter(m => m.success).length;
  }

  getFailedLoads(): LoadingMetrics[] {
    return this.loadingMetrics.filter(m => !m.success);
  }

  clearMetrics(): void {
    this.loadingMetrics = [];
    this.loadingStartTimes.clear();
  }
}
